export default __webpack_public_path__ + "static/media/CA-13 after Install app pop-up.3093f1e5.png";